import React from "react";
import { Link } from "react-router-dom";
import { Paper } from "@mui/material";
import Seo from "../../components/seo";
import "./LegalNoticePage.css";

const Section = ({ title, children }) => (
  <section className="legal-notice-section">
    <h2>{title}</h2>
    {children}
  </section>
);

export default function LegalNoticePage() {
  return (
    <>
      <Seo
        title="Mentions légales | Bio-Technofix"
        description="Informations légales, propriété intellectuelle et protection des données du site Bio-Technofix."
        path="/mentions-legales"
      />
      <Paper className="legal-notice-page" elevation={1}>
        <header className="legal-notice-header">
          <p className="legal-notice-eyebrow">Informations juridiques</p>
          <h1>Mentions légales</h1>
          <p>
            Les présentes mentions définissent les conditions d’utilisation du site
            <strong> bio-technofix.com</strong> et identifient son éditeur.
          </p>
        </header>

        <div className="legal-notice-grid">
          <Section title="Éditeur du site">
            <p><strong>BIO TECHNOFIX</strong>, société à responsabilité limitée au capital de 30 000 €.</p>
            <p>
              5 rue Denis Papin, ZA La Mare du Milieu – Lot C<br />
              91630 Guibeville, France
            </p>
            <ul>
              <li>SIREN : 391 580 933</li>
              <li>SIRET : 391 580 933 00045</li>
              <li>RCS : Évry 391 580 933</li>
              <li>TVA intracommunautaire : FR61 391 580 933</li>
              <li>Téléphone : <a href="tel:+33155581515">01 55 58 15 15</a></li>
            </ul>
          </Section>

          <Section title="Publication et contact">
            <p>
              Directeur de la publication : <strong>Philippe Malzieu</strong>,
              en qualité de gérant de BIO TECHNOFIX.
            </p>
            <p>
              Pour toute question relative au site, à son contenu ou à son fonctionnement,
              utilisez notre <Link to="/contact/us">formulaire de contact</Link>.
            </p>
          </Section>

          <Section title="Hébergement et infogérance">
            <p>
              Le site est infogéré par <strong>EPIXELIC</strong>, SARL située
              au 31 cours des Juilliottes, 94700 Maisons-Alfort, France.
            </p>
            <p>
              Téléphone : <a href="tel:+33148934000">01 48 93 40 00</a>
            </p>
            <p>
              Le serveur est hébergé par <strong>OVH SAS</strong>, 2 rue Kellermann,
              59100 Roubaix, France. Téléphone : <a href="tel:1007">1007</a>.
            </p>
          </Section>

          <Section title="Propriété intellectuelle">
            <p>
              Les textes, visuels, marques, catalogues, logos et autres contenus publiés
              sur ce site sont protégés par le droit de la propriété intellectuelle.
              Toute reproduction, adaptation ou diffusion, totale ou partielle, nécessite
              l’autorisation préalable de BIO TECHNOFIX ou du titulaire concerné.
            </p>
          </Section>

          <Section title="Responsabilité">
            <p>
              BIO TECHNOFIX veille à l’exactitude des informations publiées, sans pouvoir
              garantir qu’elles soient exhaustives ou constamment à jour. Les informations
              et prix présentés sont indicatifs. L’utilisateur reste responsable de son
              équipement, de sa connexion et de l’usage qu’il fait du site.
            </p>
          </Section>

          <Section title="Données personnelles">
            <p>
              Les données transmises depuis les formulaires ou l’espace client sont utilisées
              pour répondre aux demandes, gérer les comptes et établir les devis. Vous pouvez
              demander l’accès, la rectification ou l’effacement de vos données via le
              <Link to="/contact/us"> formulaire de contact</Link>. Vous pouvez également
              introduire une réclamation auprès de la CNIL.
            </p>
          </Section>

          <Section title="Cookies et mesure d’audience">
            <p>
              Le site utilise des cookies nécessaires à son fonctionnement. Les cookies de
              mesure d’audience et d’analyse du comportement ne sont déposés qu’après votre
              accord dans la bannière de consentement. Vous pouvez modifier votre choix à tout
              moment depuis le lien « Gérer les cookies » présent dans le pied de page.
            </p>
          </Section>

          <Section title="Liens externes">
            <p>
              Le site peut contenir des liens vers des services tiers. BIO TECHNOFIX ne
              contrôle pas leur contenu, leur disponibilité ni leurs pratiques de protection
              des données et ne peut en être tenue responsable.
            </p>
          </Section>

          <Section title="Droit applicable">
            <p>
              Le présent site et ses mentions légales sont soumis au droit français.
              Les présentes informations peuvent évoluer afin de tenir compte des changements
              réglementaires, techniques ou fonctionnels du site.
            </p>
          </Section>
        </div>

        <p className="legal-notice-update">Dernière mise à jour : octobre 2026</p>
      </Paper>
    </>
  );
}
